/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Ils } from '../../models/ils';
import { UpdateIlsMetadataDto } from '../../models/update-ils-metadata-dto';

export interface IlsControllerUpdateMetadata$Params {
  ilsId: string;
      body: UpdateIlsMetadataDto
}

export function ilsControllerUpdateMetadata(http: HttpClient, rootUrl: string, params: IlsControllerUpdateMetadata$Params, context?: HttpContext): Observable<StrictHttpResponse<Ils>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerUpdateMetadata.PATH, 'patch');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Ils>;
    })
  );
}

ilsControllerUpdateMetadata.PATH = '/ils/{ilsId}/metadata';
